import { useGenericList } from '@app/hooks/useGenericList';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog, IconButton, LinearProgress, TablePagination } from '@mui/material';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { HeaderEventQuestions } from './HeaderEventQuestions';
import { QuestionListItem } from './QuestionListItem';

interface EventQuestionsProps {
  open: boolean;
  selected: GenericObject[];
  selectOnlyOne?: boolean;
  handleClose(): void;
  removeQuestion(item: GenericObject): void;
  isQuestionSelected(item: GenericObject): boolean;
  handleChangeSelected(selected: GenericObject[]): void;
}

export const EventQuestions = ({
  handleClose,
  open,
  removeQuestion,
  selected,
  handleChangeSelected,
  isQuestionSelected,
}: EventQuestionsProps) => {
  const { data, isLoading, total, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, handleChangeFilters } =
    useGenericList('questions', { customRowsPerPage: 100 });

  const selectQuestion = (questionObj: GenericObject) => {
    const alreadySelected = isQuestionSelected(questionObj);
    if (alreadySelected) {
      removeQuestion(questionObj);
      return;
    }
    selected.unshift(questionObj);
    handleChangeSelected([...selected]);
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="lg">
      <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '10px' }}>
        <IconButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </div>
      <HeaderEventQuestions handleChangeFilters={handleChangeFilters} title={'Add Question'} />
      {isLoading && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '32vw',
          padding: 10,
          maxHeight: '60vh',
          overflow: 'auto',
        }}>
          <div>
            {data &&
              data.map((questionObj: GenericObject) => (
                <QuestionListItem
                  key={questionObj.id as number}
                  questionObj={questionObj}
                  selectQuestion={selectQuestion}
                  isQuestionSelected={isQuestionSelected}
                />
            ))}
          </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px' }}>
        <Button onClick={handleClose} variant="contained">
          DONE
        </Button>
        <TablePagination
          component="div"
          count={total ? total : 0}
          page={page ? page : 0}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage ? rowsPerPage : 10}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </Dialog>
  );
};
